import {Routes} from '@angular/router'
import {Login} from './components/login/login'
import {LoggedIn} from './components/logged-in/logged-in'

export const routes: Routes = [
  {
    path: 'login',
    component: Login
  },
  {
    path: 'logged-in',
    component: LoggedIn
  },
  {
    path: 'authenticated',
    loadComponent: () => import('./components/authenticated/authenticated').then(c => c.Authenticated)
  },
  {
    path: 'login-settings',
    loadComponent: () => import('./components/login-settings/login-settings').then(c => c.LoginSettings)
  },
  {
    path: 'deploy',
    loadChildren: () => import('./deploy/routes')
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    path: '**',
    redirectTo: 'login'
  }
]
